import PropTypes from 'prop-types';
import Separator from '../Separator/Separator';

// Import des images de la question 1
import Q1ImageFantome from "../../assets/img/q1/A_1920_Radio_Ducretet_75.webp";
import Q1Image1_desktop from "../../assets/img/q1/desktop/02_1920_Enregistrement_Concert_RESIZED_75.webp";
import Q1Image1_mobile from "../../assets/img/q1/mobile/02_1920_Enregistrement_Concert_RESIZED_75.webp";
import Q1Video1_mp4 from "../../assets/video/q1/03_1920_Femmes_ecoutent_radio.mp4";
import Q1Video1_webm from "../../assets/video/q1/03_1920_Femmes_ecoutent_radio.webm";

// Import des images de la question 2 - impossible d'exporter en webp
import Q2ImageFantome from "../../assets/img/q2/B_1938_Radio_Sonora_75.webp";
import Q2Image1_desktop from "../../assets/img/q2/desktop/04_1938_Canular_Orson_Welles_RESIZED_75.jpg";
import Q2Image1_mobile from "../../assets/img/q2/mobile/04_1938_Canular_Orson_Welles_RESIZED_75.jpg";
import Q2Image2_desktop from "../../assets/img/q2/desktop/05_1938_De_Gaulle_18juin_RESIZED_75.webp";
import Q2Image2_mobile from "../../assets/img/q2/mobile/05_1938_De_Gaulle_18juin_RESIZED_75.webp";

// Import des images de la question 3
import Q3ImageFantome from "../../assets/img/q3/C_1950_Radio_Microcapte_75.webp";
import Q3Image1_desktop from "../../assets/img/q3/desktop/06_1960_Autoradio_RESIZED_75.webp";
import Q3Image1_mobile from "../../assets/img/q3/mobile/06_1960_Autoradio_RESIZED_75.webp";
import Q3Image2_desktop from "../../assets/img/q3/desktop/07_1960_Match_Baseball-retouchee_RESIZED_75.webp";
import Q3Image2_mobile from "../../assets/img/q3/mobile/07_1960_Match_Baseball-retouchee_RESIZED_75.webp";

// Import des images de la question 4
import Q4ImageFantome from "../../assets/img/q4/D_1968_Radio_Boule_Philipps_75.webp";
import Q4Image1_desktop from "../../assets/img/q4/desktop/08_1968_Femme_Leve_Poing_RESIZED_75.webp";
import Q4Image1_mobile from "../../assets/img/q4/mobile/08_1968_Femme_Leve_Poing_RESIZED_75.webp";
import Q4Image2_desktop from "../../assets/img/q4/desktop/10_1968_Radio_Verte_RESIZED_75.webp";
import Q4Image2_mobile from "../../assets/img/q4/mobile/10_1968_Radio_Verte_RESIZED_75.webp";
import Q4Video1_mp4 from "../../assets/video/q4/09_1968_Lancer_de_pave.mp4";
import Q4Video1_webm from "../../assets/video/q4/09_1968_Lancer_de_pave.webm";

// Import des images de la question 5
import Q5ImageFantome from "../../assets/img/q5/E_1980_Radio_Boombox_Promax_75.webp";
import Q5Image1_desktop from "../../assets/img/q5/desktop/11_1980_Breakdance_1042_75.webp";
import Q5Image1_mobile from "../../assets/img/q5/mobile/11_1980_Breakdance_600_75.webp";
import Q5Video1_mp4 from "../../assets/video/q5/12_1980_Hard_Rock.mp4";
import Q5Video1_webm from "../../assets/video/q5/12_1980_Hard_Rock.webm";

// Import des images de la question 6
import Q6ImageFantome from "../../assets/img/q6/F_2000_Airpods_75.webp";
import Q6Video1_mp4 from "../../assets/video/q6/13_2000_Personne_Metro.mp4";
import Q6Video1_webm from "../../assets/video/q6/13_2000_Personne_Metro.webm";

// Imports
import AnimationFigureMultipleLines from '../Animation/AnimationFigureMultipleLines/AnimationFigureMultipleLines';
import Figure from '../Figure/Figure';
import AnimationStripedItemsFromList from '../Animation/AnimationStripedItemsFromList/AnimationStripedItemsFromList';
import AnimationDuBricolage from '../Animation/AnimationDuBricolage/AnimationDuBricolage';
import AnimationSoucoupe from '../Animation/AnimationSoucoupe/AnimationSoucoupe';
import AnimationAaaaah from '../Animation/AnimationAaaaah/AnimationAaaaah';
import AnimationMouvement from '../Animation/AnimationMouvement/AnimationMouvement';
import AnimationDigital from '../Animation/AnimationDigital/AnimationDigital';
import AnimationHearts from '../Animation/AnimationHearts/AnimationHearts';
import AnimationColere from '../Animation/AnimationColere/AnimationColere';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

function QuestionIntroduction({ qid, length }) {
    // On met en place l'écouteur de changement de page au niveau de la question
    const progressRef = useRef(null);
    const location = useLocation();
    useEffect(() => {
        // On met en place la sécurité autour du cas de figure où le progress n'existe pas
        // Si il existe on déplace le focus dessus
        if(progressRef.current === null) return;
        progressRef.current.focus();
    }, [location])

    return (
        <div className="question-introduction__container grid--container">
            <div
                aria-label={qid + 1 + ' sur ' + length}
                className="quiz-progress"
                ref={progressRef}
                tabIndex={-1}>
                <p>
                    <span aria-hidden="true">{qid + 1}</span>
                    <span aria-hidden="true">{length}</span>
                </p>
            </div>
            {qid === 0 && <IntroductionQuestionUne />}
            {qid === 1 && <IntroductionQuestionDeux />}
            {qid === 2 && <IntroductionQuestionTrois />}
            {qid === 3 && <IntroductionQuestionQuatre />}
            {qid === 4 && <IntroductionQuestionCinq />}
            {qid === 5 && <IntroductionQuestionSix />}
        </div>
    )
}

QuestionIntroduction.propTypes = {
    qid: PropTypes.number.isRequired,
    length: PropTypes.number.isRequired,
}

export default QuestionIntroduction;

function IntroductionQuestionUne() {
    return (
        <>
            <h1 className="quiz-title">
                <span>1920&#8203;</span>
                <span>1937</span>
            </h1>
            <Figure
                className="desktop-col-start--4 desktop-col-end--8 mobile-col-start--2 mobile-col-end--4 quiz-figure--fantome"
                medias={{'desktop': Q1ImageFantome, 'mobile': Q1ImageFantome}}
                hasCreditsPopin={false}
                hasCaption={false} />
            <Separator kind="partial" orient="end" size="normal" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    On donne le cours de la bourse, on lit le journal, on annonce la
                    météo et, pour détendre l’atmosphère... on diffuse des concerts :
                </p>
            </div>
            <Separator kind="partial" orient="start" size="x-small" />
            <AnimationFigureMultipleLines
                className="desktop-col-start--1 desktop-col-end--13 mobile-col-start--1 mobile-col-end--7 quiz-figure--1"
                mediaContainerClassName="desktop-col-start--1 desktop-col-end--14"
                imgs={{'desktop': Q1Image1_desktop, 'mobile': Q1Image1_mobile}}
                hasCreditsPopin={true}
                credits={<><p>Orchestre des concerts Radiola, au studio de TSF du journal Le Matin, boulevard Haussmann Paris, 1922. </p><p>In <em>La Nature</em>, 1934, en ligne sur <a target="_blank" className="link link--external" href="http://cnum.cnam.fr/redir?4KY28.127">Cnum - Conservatoire numérique des Arts et Métiers.</a></p></>}
                hasCaption={true}
                caption={[
                    (<span key="c3">Le Déluge</span>),
                    (<span key="c2">Roméo et Juliette</span>),
                    (<span key="c1">La Damnation de Faust</span>),
                ]} />
            <Separator kind="partial" orient="end" size="normal" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    Oui, la radio, à ses débuts, c’est beau, c’est édifiant, c’est
                    sérieux mais c’est aussi...
                </p>
            </div>
            <Separator kind="partial" orient="start" size="small" />
            <AnimationDuBricolage
                id="du-bricolage"
                containerClassName="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7" />
            <Separator kind="partial" orient="end" size="small" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">car les premières années, pour en profiter, il faut savoir se débrouiller :</p>
                <AnimationStripedItemsFromList
                    className="is-highlight"
                    itemsToStrip={[
                        "Brancher un cadre antenne",
                        "Connecter l’accumulateur au récepteur",
                        "Ajouter un haut-parleur"
                    ]}
                    showNewItems={false}
                />
            </div>
            <Separator kind="partial" orient="start" size="normal" />
            <Figure
                className="desktop-col-start--2 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--video quiz-figure--2"
                mediaType="video"
                medias={{'mp4': Q1Video1_mp4, 'webm': Q1Video1_webm}}
                hasCreditsPopin={true}
                credits={<><p>Jeunes femmes écoutant la radio, vers 1920.</p><p>&copy; Archive Films/Getty Images</p></>}
                hasCaption={false} />
            <Separator kind="partial" orient="end" size="normal" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    Par la suite, plus besoin de l’acheter en kit. La radio est vendue assemblée et prête à l’emploi.
                </p>
                <p className="quiz-paragraph">
                    Dans tous les cas, elle est trop volumineuse pour être transportée (simplement).
                </p>
            </div>
            <Separator kind="partial" orient="start" size="normal" />
        </>
    )
}

function IntroductionQuestionDeux() {
    return (
        <>
            <h1 className="quiz-title">
                <span>1938&#8203;</span>
                <span>1950</span>
            </h1>
            <Figure
                className="desktop-col-start--4 desktop-col-end--8 mobile-col-start--2 mobile-col-end--4 quiz-figure--fantome"
                medias={{'desktop': Q2ImageFantome, 'mobile': Q2ImageFantome}}
                hasCreditsPopin={false}
                hasCaption={false} />
            <Separator kind="partial" orient="end" size="normal" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    Les Martiens descendent les humains à tour de bras.
                </p>
            </div>
            <Separator kind="partial" orient="start" size="x-large" />
            <AnimationSoucoupe
                containerClassName="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7" />
            <Separator kind="partial" orient="end" size="x-large" />
            <div className="row-container quiz-row-container">
                <h2>
                    <span className="is-highlight">impossible</span> de les arrêter
                </h2>
                <p className="quiz-paragraph">
                    Ils se rapprochent de New York à toute vitesse !
                </p>
            </div>
            <Separator kind="partial" orient="start" size="x-large" />
            <AnimationAaaaah
                containerClassName="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7" />
            <Separator kind="partial" orient="end" size="small" />
            <div className="row-container quiz-row-container desktop-col-start--3 mobile-col-start--2">
                <p className="quiz-paragraph">
                    En 1938, le réseau CBS diffuse un canular d’Orson Welles.<br/>
                </p>
                <p>
                    Pendant plusieurs heures, de <span className="is-highlight">faux</span> journalistes rapportent la{' '}
                    <span className="is-highlight">fausse</span> invasion du <span className="is-highlight">vrai</span> New York
                    par de <span className="is-highlight">faux</span> aliens.
                </p>
            </div>
            <Separator kind="partial" orient="start" size="small" />
            <Figure
                className="desktop-col-start--3 desktop-col-end--11 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                medias={{'desktop': Q2Image1_desktop, 'mobile': Q2Image1_mobile}}
                hasCreditsPopin={true}
                credits={<><p>Lecture de La guerre des mondes, de H.G. Wells, par Orson Welles dans les studios de CBS, New York, 1938.</p><p>&copy; Gamma-Keystone/Getty Images</p></>}
                hasCaption={false} />
            <div className="row-container quiz-row-container desktop-col-start--3 mobile-col-start--2">
                <p className="quiz-paragraph">Le lendemain, la presse évoquera des scènes de panique, fausses elles aussi.</p>
            </div>
            <Separator kind="complete" size="x-large" />
            <div className="row-container quiz-row-container desktop-col-start--3 mobile-col-start--2">
                <p className="quiz-paragraph">
                    Deux ans plus tard, une autre annonce répond à une invasion&nbsp;; bien réelle celle-ci.
                    L’armée allemande occupe le nord de la France.
                </p>
                <p className="quiz-paragraph">
                    Depuis Londres, où il s’est réfugié, le général de Gaulle lance un appel aux français :
                </p>
            </div>
            <Figure
                className="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7 quiz-figure--2 container-image--full-height"
                medias={{'desktop': Q2Image2_desktop, 'mobile': Q2Image2_mobile}}
                hasCreditsPopin={true}
                credits={<><p>Le général Charles de Gaulle au micro de la BBC à Londres, 1941.</p><p>&copy; Hulton-Deutsch Collection/CORBIS/Corbis via Getty Images</p></>}
                hasCaption={false} />
            <div className="row-container quiz-row-container container--full-height">
                <p className="quiz-paragraph">
                    Résistez.
                </p>
            </div>
        </>
    )
}

function IntroductionQuestionTrois() {
    return (
        <>
            <h1 className="quiz-title">
                <span>1950&#8203;</span>
                <span>1967</span>
            </h1>
            <Figure
                className="desktop-col-start--4 desktop-col-end--8 mobile-col-start--2 mobile-col-end--4 quiz-figure--fantome"
                medias={{'desktop': Q3ImageFantome, 'mobile': Q3ImageFantome}}
                hasCreditsPopin={false}
                hasCaption={false} />
            <Separator kind="partial" orient="end" size="normal" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    Les progrès techniques ont rendu les radios plus petites, plus légères et donc transportables.
                    La radio se met en...
                </p>
            </div>
            <AnimationMouvement
                id="Mouvement"
                containerClassName="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7" />
            <AnimationFigureMultipleLines
                className="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7 anim--1 quiz-figure--1"
                mediaContainerClassName="desktop-col-start--1 desktop-col-end--14 mobile-col-start--1 mobile-col-end--6"
                imgs={{'desktop': Q3Image1_desktop, 'mobile': Q3Image1_mobile}}
                hasCreditsPopin={true}
                credits={<><p>Le premier autoradio au Salon de l&apos;automobile de Francfort-sur-le-Main, Allemagne, 1959.</p><p>&copy; Keystone-France/Gamma-Keystone via Getty Images</p></>}
                hasCaption={true}
                caption={[
                    (<span key="c1">Pratique pour s’ambiancer&nbsp;en <br/>direction d’une soirée</span>)
                ]} />
            <AnimationFigureMultipleLines
                className="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7 anim--2 quiz-figure--2"
                mediaContainerClassName="desktop-col-start--1 desktop-col-end--14 mobile-col-start--1 mobile-col-end--6"
                imgs={{'desktop': Q3Image2_desktop, 'mobile': Q3Image2_mobile}}
                hasCreditsPopin={true}
                credits={<><p>Dans les gradins. Match de baseball Yankees-Red Sox, 23 septembre 1950.</p><p>&copy; Bettmann Archives/Getty Images</p></>}
                hasCaption={true}
                caption={[
                    (<span key="c1">ou comprendre le match <br/>auquel on assiste</span>)
                ]} />
        </>
    )
}

function IntroductionQuestionQuatre() {
    return (
        <>
            <h1 className="quiz-title">
                <span>1968&#8203;</span>
                <span>1980</span>
            </h1>
            <Figure
                className="desktop-col-start--4 desktop-col-end--8 mobile-col-start--2 mobile-col-end--4 quiz-figure--fantome"
                medias={{'desktop': Q4ImageFantome, 'mobile': Q4ImageFantome}}
                hasCreditsPopin={false}
                hasCaption={false} />
            <Separator kind="partial" orient="end" size="normal" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    Sous les pavés, la mer et sur les ondes...
                </p>
            </div>
            <AnimationColere
                id="Colere"
                className="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7"
                containerClassName="quiz-figure--1"
                imgs={{'desktop': Q4Image1_desktop, 'mobile': Q4Image1_mobile}}
                credits={<><p>Paris, mai 1968.</p><p>&copy; Marc Riboud / Fonds Marc Riboud au musée Guimet</p></>} />
            <Separator kind="partial" orient="end" size="small" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    En mai 68, les émeutes sont essentiellement couvertes par des
                    radios émettant depuis l’étranger.
                </p>
                <p className="quiz-paragraph">
                    Moins soumises au contrôle de l’État français, elles se font
                    l’écho des <span className="is-highlight">revendications sociales et politiques</span>.
                </p>
            </div>
            <Separator kind="partial" orient="start" size="small" />
            <Figure
                className="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7 quiz-figure--video quiz-figure--2 container--dark container--full-height"
                mediaContainerClassName="desktop-col-start--5 desktop-col-end--11 mobile-col-start--1 mobile-col-end--7"
                mediaType="video"
                medias={{'mp4': Q4Video1_mp4, 'webm': Q4Video1_webm}}
                hasCreditsPopin={true}
                credits={<><p>Mai 68.</p><p>&copy; ITN/Getty Images</p></>}
                hasCaption={false} />
            <Separator kind="partial" orient="end" size="small" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    Quelques années plus tard, la radio, elle aussi, entame sa révolution.
                    Des stations émettent sans autorisation.
                </p>
                <p className="quiz-paragraph">
                    <span className="is-highlight">Contestataires et effrontées</span>,
                    les radios libres arrivent sur les ondes sans y être invitées.
                </p>
                <p className="quiz-paragraph">
                    Sur :
                </p>
            </div>
            <AnimationFigureMultipleLines
                className="desktop-col-start--1 desktop-col-end--14 mobile-col-start--1 mobile-col-end--7 quiz-figure--2"
                mediaContainerClassName="desktop-col-start--1 desktop-col-end--13 mobile-col-start--1 mobile-col-end--6"
                imgs={{'desktop': Q4Image2_desktop, 'mobile': Q4Image2_mobile}}
                hasCreditsPopin={true}
                credits={<><p>Dans le « studio » de Radio Verte, radio clandestine émettant à Paris, 16 mai 1977.</p><p>&copy; Laurent Maous/Gamma-Rapho via Getty Images</p></>}
                hasCaption={true}
                caption={[
                    (<span key="c1">Radio Verte</span>),
                    (<span key="c2">Radio Ivre</span>),
                    (<span key="c2">Radio Ici et Maintenant</span>),
                ]} />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph container--full-height">
                    Il est interdit d’interdire.
                </p>
            </div>

        </>
    )
}

function IntroductionQuestionCinq() {
    return (
        <>
            <h1 className="quiz-title">
                <span>1980&#8203;</span>
                <span>2000</span>
            </h1>
            <Figure
                className="desktop-col-start--4 desktop-col-end--8 mobile-col-start--2 mobile-col-end--4 quiz-figure--fantome"
                medias={{'desktop': Q5ImageFantome, 'mobile': Q5ImageFantome}}
                hasCreditsPopin={false}
                hasCaption={false} />
            <Separator kind="partial" orient="end" size="normal" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    Des ondes enfin libres !
                </p>
                <p className="quiz-paragraph">
                    Peu après l’élection de François Mitterrand, c’est
                    la fin du monopole d’État sur les fréquences.
                </p>
                <p className="quiz-paragraph">
                    C’est l’explosion :
                </p>
                <AnimationStripedItemsFromList
                    className="is-highlight"
                    itemsToStrip={[
                        "Nouvelle radio des jeunes",
                        "La Voix du Lézard",
                        "Ça bouge dans ma tête"
                    ]}
                    showNewItems={true}
                    itemsToShow={[
                        "NRJ",
                        "Skyrock",
                        "Oüi FM"
                    ]}
                />
                <p className="quiz-paragraph">
                    des centaines de radios voient le jour.
                </p>
            </div>
            <Separator kind="complete" size="x-large" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    Pour se faire une place, elles vont se spécialiser. En <span className="is-highlight">rap, dance,
                    hip-hop</span>&nbsp;: la radio accompagne l&apos;émergence de ces communautés.
                </p>
            </div>
            <Separator kind="partial" orient="start" size="normal" />
            <Figure
                className="desktop-col-start--2 desktop-col-end--9 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                mediaContainerClassName="desktop-col-start--4 desktop-col-end--12"
                medias={{'desktop': Q5Image1_desktop, 'mobile': Q5Image1_mobile}}
                hasCreditsPopin={true}
                credits={<><p>Breakdance à Marseille, années 90.</p><p>&copy; Photo by Jean-Erick PASQUIER/Gamma-Rapho via Getty</p></>}
                hasCaption={false} />
            <Separator kind="partial" orient="end" size="normal" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    Sur les ondes comme dans la rue, on sort les casquettes, les
                    cuirs, les baggy.
                </p>
            </div>
            <Separator kind="partial" orient="start" size="normal" />
            <Figure
                className="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7 quiz-figure--video quiz-figure--2 container--dark container--full-height container-image--absolute-caption container-image--absolute-caption-centered container-image--absolute-caption-highlighted"
                mediaContainerClassName="desktop-col-start--5 desktop-col-end--11 mobile-col-start--1 mobile-col-end--7"
                mediaType="video"
                medias={{'mp4': Q5Video1_mp4, 'webm': Q5Video1_webm}}
                hasCreditsPopin={true}
                credits={<><p>Le hard rock en France, «&nbsp;un sacré marché&nbsp;». Émission Les enfants du rock, 1984.</p><p>&copy; Les enfants du rock/France2/INA</p></>}
                hasCaption={true}
                caption={[(<span key="c1">C&apos;est party</span>)]} />
        </>
    )
}

function IntroductionQuestionSix() {
    return (
        <>
            <h1 className="quiz-title">
                <span>2000&#8203;</span>
                <span>2025</span>
            </h1>
            <Figure
                className="desktop-col-start--4 desktop-col-end--8 mobile-col-start--2 mobile-col-end--4 quiz-figure--fantome"
                medias={{'desktop': Q6ImageFantome, 'mobile': Q6ImageFantome}}
                hasCreditsPopin={false}
                hasCaption={false} />
            <Separator kind="partial" orient="end" size="normal" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    Il est venu le temps du
                </p>
            </div>
            <AnimationDigital
                containerClassName="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7" />
            <Separator kind="partial" orient="end" size="normal" />
            <div className="row-container quiz-row-container">
                <p className="quiz-paragraph">
                    En ligne, de nouveaux acteurs créent et donnent accès à des
                    contenus audio.
                </p>
            </div>
            <Separator kind="partial" orient="start" size="normal" />
            <Figure
                className="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7 quiz-figure--video quiz-figure--1 container--full-height"
                mediaContainerClassName="desktop-col-start--4 desktop-col-end--12 mobile-col-start--1 mobile-col-end--7"
                mediaType="video"
                medias={{'mp4': Q6Video1_mp4, 'webm': Q6Video1_webm}}
                hasCreditsPopin={true}
                credits={<><p>Écoute au casque dans les transports en commun.</p><p>&copy; Counter/Getty Images</p></>}
                hasCaption={false} />
            <Separator kind="partial" orient="end" size="large" />
            <AnimationHearts />
            <div className="row-container quiz-row-container container--full-height">
                <p className="quiz-paragraph">
                    On interagit.
                </p>
            </div>
        </>
    )
}
